import { useContext } from 'react'
import { closingReqContext } from './closingReqContext'

export function useClosingReqContext() {
  const ctx = useContext(closingReqContext)

  if (ctx === undefined)
    throw Error('Must be descendant of ClosingReqContextProvider')

  return ctx
}
